<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <custom-data-table :tableName="tableName" :header="headers" :items="items" :loading="loading" visibleCreate @stored="stored" :visibleStore="updatePermission">
          <template v-slot:action="{ item }">
            <v-btn v-if="updatePermission" class="mr-2" depressed small @click.stop="updated(item)" color="primary">編集</v-btn>
            <v-btn v-if="deletePermission" class="mr-2" depressed small @click.stop="deleted(item)" color="error">削除</v-btn>
          </template>
        </custom-data-table>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleDelete
        @deleted="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import AggregateApi from "@/api/aggregate-api";
import CustomDataTable from "@/components/custom_ui/CustomDataTable";
import CustomDialog from "@/components/custom_ui/CustomDialog";

export default {
  name: "AggregateMaster",
  components: {
    CustomDataTable,
    CustomDialog
  },
  props: ["user"],
  data: () => ({
    // 共通コンポーネント: データテーブル関連
    loading: false,
    tableName: "集計費目情報",
    headers: [
      { text: "集計費目名", value: "name", sortable: false, align: 'left' },
      { text: 'アクション', value: 'action', sortable: false, align: 'left'},
    ],
    items: [],

    // 削除ダイアログ
    dialogMaxWith: 500,
    dialogTitle: "",
    dialogItems: [],
    dialogDrawer: false,
    deleteId: null,

    // 権限
    updatePermission: true,
    deletePermission: true
  }),
  created() {
    this.initialize();
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
      this.isLoading();
      if (this.user.role_id == 0) {
        this.updatePermission = this.user.permission_config.CTSG00009.update;
        this.deletePermission = this.user.permission_config.CTSG00009.delete;
      }
      this.aggregateApi = new AggregateApi();
      const promise = this.aggregateApi.list();
      promise.then(response => {
        this.items = response.data.body.aggregate_list;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error",error.response.data.message);
            this.$router.push({ name: "Dashboard" })
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    //新規作成ボタン押下時
    stored() {
      this.$router.push({ name: 'AggregateMasterEntry' });
    },
    //編集ボタン押下時
    updated(item) {
      this.$router.push({ name: 'AggregateMasterEdit', params: { id: item.id } });
    },
    //削除ボタン押下時
    deleted(item) {
      this.deleteId = item.id;
      this.dialogTitle = "削除しますか？";
      this.dialogItems = [
          { name: "集計費目名", value: item.name },
      ];
      this.dialogDrawer = true;
    },
    dialogCancel() {
      this.dialogDrawer = false;
    },
    // ダイアログ削除ボタン押下時
    submit() {
      this.isLoading();
      // 集計費目IDを選択済みアイテム情報から取得
      const promise = this.aggregateApi.delete(this.deleteId);
      promise.then((response) => {
        this.items = this.items.filter((item) => {
            return (item.id !== this.deleteId);
        });
        this.deleteId = null;
        this.dialogDrawer = false;
        this.$emit("success", response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.dialogDrawer = false;
            this.$emit('logoutConform');
          } else {
            this.$emit("error",error.response.data.message);
          }
        } else {
          this.$emit("error","サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    }
  }
};
</script>
